import { render, staticRenderFns } from "./search-header.vue?vue&type=template&id=4957b27f&scoped=true&"
import script from "./search-header.vue?vue&type=script&lang=js&"
export * from "./search-header.vue?vue&type=script&lang=js&"
import style0 from "./search-header.vue?vue&type=style&index=0&id=4957b27f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4957b27f",
  null
  
)

export default component.exports